import { useHasUpcomingCanceledSubscription } from '../../hooks/useEligibleForResurrectionBanner';
import { MaybeHasFeatureLoss } from './MaybeHasFeatureLoss';
import { jsx as _jsx } from "react/jsx-runtime";
export const MaybeHasCanceledSubscriptions = ({
  featureLimitName,
  logExposure,
  treatments
}) => {
  const {
    loading,
    upcomingRenewalSubscriptions,
    allSubscriptions
  } = useHasUpcomingCanceledSubscription();
  if (loading) {
    return null;
  }

  // Example of upcomingRenewalSubscriptions:
  // [{
  //     subscriptionRenewalDate: '2025-11-11',
  //     productApiName: 'crm-suite-starter-bundle',
  //     subscriptionId: 123,
  //   },{
  //     subscriptionRenewalDate: '2025-11-11',
  //     productApiName: 'core-seats-starter',
  //     subscriptionId: 456,
  //   }];
  if (!upcomingRenewalSubscriptions || !allSubscriptions) {
    return null;
  }
  return /*#__PURE__*/_jsx(MaybeHasFeatureLoss, {
    featureLimitName: featureLimitName,
    logExposure: logExposure,
    treatments: treatments,
    upcomingRenewalSubscriptions: upcomingRenewalSubscriptions,
    allSubscriptions: allSubscriptions
  });
};